"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPhoneNumber = exports.isEmail = void 0;
const InputValidationError_1 = require("./InputValidationError");
const emailValidationRegex = /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\])$/;
function isEmail(value, errorMessage) {
    if (emailValidationRegex.test(value)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.isEmail = isEmail;
const phoneNumberValidationRegex = /^([0-9]{3,17})$/;
function isPhoneNumber(value, errorMessage) {
    if (phoneNumberValidationRegex.test(value)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.isPhoneNumber = isPhoneNumber;
